<template>
  <div>
    <div class="p-10 bg-gray-100 bg-opacity-70">
      <div class="flex justify-center">
        <h2 class="font-bold text-5xl text-gray-700 mt-2">
          Welcome to Flosuite
        </h2>
      </div>
      <p class="px-24 mt-12 text-xl text-gray-500 leading-relaxed">
        Looking for a florist management system? flosuite provides seller-side
        web pages to easily manage your florist inventory. Easily add and
        delete, update information at any time. View and manage by category.
      </p>
    </div>

    <section class="bg-gray-100 px-6">
      <el-carousel height="600px" :interval="5000">
        <el-carousel-item v-for="flower in flowers" :key="flower.id">
          <h3>{{ flower.name }}</h3>
          <img :src="flower.image" :alt="flower.name" />
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- <img
      src="https://ucarecdn.com/e27a86f2-e44b-4652-8d27-fcb12cca06e1/dianaolfertJZVrDQAm_gkunsplash.jpg"
      alt="flower"
    /> -->
    <!-- <img
      src="https://ucarecdn.com/e62414d4-701e-4d27-b79f-ba3c0cfcd2d6/andriykopodilnykkfpfEtWFlNwunsplash.jpg"
      alt="flower"
    />
    <img
      src="https://ucarecdn.com/2a4664ab-63fc-4c74-807b-8bf24d06a5e6/theahdcXDCeQYYmQ3Yunsplash1.jpg"
      alt=""
    />
    <img
      src="https://ucarecdn.com/2aec95c1-bbe8-44d0-9ebd-a29aa132278c/anniespratt38yKQLL11d8unsplash.jpg"
      alt=""
    /> -->
    <!-- <el-carousel :interval="5000" arrow="always">
      <el-carousel-item v-for="item in 4" :key="item">
        <h3>{{ item }}</h3>
      </el-carousel-item>
    </el-carousel> -->
  </div>
</template>

<script>
import { db } from "@/db";

export default {
  name: "Home",
  data: function () {
    return {
      flowers: [],
      // item: [
      //   "https://ucarecdn.com/e27a86f2-e44b-4652-8d27-fcb12cca06e1/dianaolfertJZVrDQAm_gkunsplash.jpg",
      //   "https://ucarecdn.com/2a4664ab-63fc-4c74-807b-8bf24d06a5e6/theahdcXDCeQYYmQ3Yunsplash1.jpg",
      //   "https://ucarecdn.com/f8aa2d31-2a9b-4e4c-8c8e-b37b9130f57f/anniesprattt0cf4fLj5x0unsplash.jpg",
      //   "https://ucarecdn.com/4d99c1a3-e09e-4166-b2e1-a9c744053a61/veriivanovawhOkVvf0_hUunsplash.jpg",
      // ],
    };
  },
  components: {
    // MyHeader,
    // InputCheckbox,
  },
  firestore: {
    flowers: db.collection("homepages"),
  },
};
</script>

<style>
body {
  background: #654ea3;
  background: linear-gradient(to top, #7a7c71, #d5b4a3);
  min-height: 100vh;
}
</style>

